'use client';

import { useMemo } from 'react';

import { useGetServiceTypesQuery } from '@/features/service-types/api/service-typesApi';
import { SmartInput } from '@web/ui';

import styles from './JobServiceTypesSection.module.scss';

export type JobServiceTypesSectionProps = {
  selectedServiceTypeIds: string[];
  fieldError?: string;
  onSelectedServiceTypeIdsChange: (ids: string[]) => void;
  readOnly?: boolean;
};

export function JobServiceTypesSection({
  selectedServiceTypeIds,
  fieldError,
  onSelectedServiceTypeIdsChange,
  readOnly = false,
}: JobServiceTypesSectionProps) {
  const { data, isFetching } = useGetServiceTypesQuery({
    page_size: 100,
    show_archived: false,
  });

  const options = useMemo(
    () =>
      (data?.data?.results ?? []).map((item) => ({
        id: item.id,
        label: item.label,
      })),
    [data],
  );

  return (
    <section className={styles.jobServiceTypesSection}>
      <h3 className={styles.jobServiceTypesSection__title}>Service Types</h3>
      <p className={styles.jobServiceTypesSection__description}>
        Select the disciplines that should appear in the planning grid on the
        next step.
      </p>
      {fieldError ? (
        <p className={styles.jobServiceTypesSection__error}>{fieldError}</p>
      ) : null}

      <div className={styles.jobServiceTypesSection__grid}>
        {options.map((option) => (
          <div key={option.id} className={styles.jobServiceTypesSection__item}>
            <SmartInput
              type="checkbox"
              name={`job-service-type-${option.id}`}
              label={option.label}
              checked={selectedServiceTypeIds.includes(option.id)}
              readOnly={readOnly || isFetching}
              onChange={(checked) => {
                if (checked) {
                  if (!selectedServiceTypeIds.includes(option.id)) {
                    onSelectedServiceTypeIdsChange([
                      ...selectedServiceTypeIds,
                      option.id,
                    ]);
                  }
                  return;
                }

                onSelectedServiceTypeIdsChange(
                  selectedServiceTypeIds.filter((id) => id !== option.id),
                );
              }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
